export default {
  search(state, search) {
    state.search = search;
  },
  limit(state, limit) {
    state.limit = limit;
  },
  page(state, page) {
    state.page = page;
  },
  serviceType(state, serviceType) {
    state.serviceType = serviceType;
  },
  visitType(state, visitType) {
    state.visitType = visitType;
  },
  status(state, status) {
    state.status = status;
  },
  loading(state, loading) {
    state.loading = loading;
  },
  sort(state, sort) {
    state.sort = sort;
  }
};
